import { render, staticRenderFns } from "./BannerStack.vue?vue&type=template&id=0044271e&scoped=true&"
import script from "./BannerStack.vue?vue&type=script&lang=js&"
export * from "./BannerStack.vue?vue&type=script&lang=js&"
import style0 from "./BannerStack.vue?vue&type=style&index=0&id=0044271e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0044271e",
  null
  
)

export default component.exports